module.exports = __webpack_public_path__ + "img/id.49cc84b4.png";